import React from 'react';
import { cn } from '../../utils/cn';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg' | 'icon';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  children?: React.ReactNode;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500 border-transparent shadow-sm',
    secondary: 'bg-slate-100 text-slate-900 hover:bg-slate-200 focus:ring-slate-500 border-transparent',
    outline: 'bg-white text-slate-700 border-slate-300 hover:bg-slate-50 focus:ring-primary-500 shadow-sm',
    ghost: 'bg-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900 focus:ring-slate-500 border-transparent',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 border-transparent shadow-sm'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-4 text-sm',
    lg: 'h-12 px-6 text-base',
    icon: 'h-10 w-10 p-2'
  };
  return <button className={cn('inline-flex items-center justify-center rounded-lg font-medium border transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none active:scale-[0.98]', variants[variant], sizes[size], className)} disabled={disabled || isLoading} {...props} data-id="element-266">
      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-267" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-268">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-269">{rightIcon}</span>}
    </button>;
}